import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import debounce from 'lodash.debounce'
import LayoutTable from '../../../../Global/LayoutTable'
import Box from '../../../../Global/Box'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { GET_TICKETS_RESOLVED_BY_USER } from '../../../../../graphql/Catalog/ReportsQueries/reportsQueries'

const GetTicketsResolvedByUser = ({ filters }) => {
  //STATES:
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    filters: { dateFrom: filters.dateFrom, dateTo: filters.dateTo },
  })
  const [dataResp, setDataResp] = useState([])

  //QUERIES:
  const { loading, error, data } = useQuery(GET_TICKETS_RESOLVED_BY_USER, {
    variables: { ...pagePagination },
    fetchPolicy: 'cache-and-network',
  })

  const handleSearch = (value) => {
    const query = value.target.value.toLowerCase()
    setPagePagination({
      ...pagePagination,
      searchQuery: query,
    })
  }

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getTicketsResolvedByUser.map((item) => {
        return list.push({
          gestor: item.user_name_complet,
          tickets: item.count_status_complet,
        })
      })
      setDataResp(list)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  useEffect(() => {
    setPagePagination((old) => ({
      ...old,
      filters: { dateFrom: filters.dateFrom, dateTo: filters.dateTo },
    }))
  }, [filters])

  return (
    <Box
      classNameHeader="card-header py-1 bg-info"
      contentHeader={
        <h3 className="card-title pl-3 mt-0">
          <div className="text-white">
            <i className={`fas fa-ticket-alt pr-2`} />
            Tickets resueltos por gestor
          </div>
        </h3>
      }
      classCardBody=" "
      content={
        <>
          <LayoutTable
            hideId
            hideActions
            hideAddNew
            configCustomCols={{
              gestor: { grow: 3 },
              tickets: { grow: 1, center: true },
            }}
            growCustom={{ gestor: 1, tickets: 0 }}
            data={dataResp}
            requery={GET_TICKETS_RESOLVED_BY_USER}
            exportImportButton={false}
            totalCount={dataResp.length}
            pagePagination={pagePagination}
            setPagePagination={setPagePagination}
            loadingData={loading}
            FilterBarPlaceholder="Buscar por gestor"
            paginationServer={false}
            withCard={''}
            classCardBody={'pt-2'}
            hideFilterBar={true}
            customHeaderComponent={
              <div className="d-flex">
                <input
                  id="searchBar2"
                  type="text"
                  className="input-field form-control position-searchInput"
                  style={{ width: 250 }}
                  placeholder={'Buscar por gestor'}
                  onChange={debounce(handleSearch, 300)}
                />
              </div>
            }
            dense={true}
            noDataComponent={
              <div className="alert alert-default-info p-1">
                No hay resultados
              </div>
            }
          />
        </>
      }
    />
  )
}

export default GetTicketsResolvedByUser
